var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.18747 7C5.18747 7.46413 5.37184 7.90925 5.70003 8.23744C6.02822 8.56563 6.47334 8.75 6.93747 8.75C7.4016 8.75 7.84672 8.56563 8.17491 8.23744C8.50309 7.90925 8.68747 7.46413 8.68747 7C8.68747 6.53587 8.50309 6.09075 8.17491 5.76256C7.84672 5.43437 7.4016 5.25 6.93747 5.25C6.47334 5.25 6.02822 5.43437 5.70003 5.76256C5.37184 6.09075 5.18747 6.53587 5.18747 7ZM13.7218 6.59688C12.2406 3.47656 10.0015 1.90625 6.99997 1.90625C3.99684 1.90625 1.75934 3.47656 0.278093 6.59844C0.21868 6.72425 0.187866 6.86165 0.187866 7.00078C0.187866 7.13991 0.21868 7.27732 0.278093 7.40312C1.75934 10.5234 3.99841 12.0938 6.99997 12.0938C10.0031 12.0938 12.2406 10.5234 13.7218 7.40156C13.8422 7.14844 13.8422 6.85469 13.7218 6.59688ZM6.93747 9.75C5.41872 9.75 4.18747 8.51875 4.18747 7C4.18747 5.48125 5.41872 4.25 6.93747 4.25C8.45622 4.25 9.68747 5.48125 9.68747 7C9.68747 8.51875 8.45622 9.75 6.93747 9.75Z",
    fill: "black",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeFilled);
export default __webpack_public_path__ + "static/media/EyeFilled.f8fb618abf1ce23a70350a9fb8b92e9c.svg";
export { ForwardRef as ReactComponent };